var React = require('react');

function Vector (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15.17 1.525a.07.07 0 00-.083-.02c-.43.192-.882.33-1.348.41.495-.373.863-.89 1.052-1.482a.072.072 0 00-.104-.084 5.751 5.751 0 01-1.793.695 3 3 0 00-2.156-.919 3 3 0 00-2.934 3.593A8.24 8.24 0 011.93.688a.071.071 0 00-.117.01 3.008 3.008 0 00-.405 1.508c0 .92.417 1.78 1.126 2.348a2.852 2.852 0 01-1.043-.338.07.07 0 00-.07 0 .072.072 0 00-.037.06v.04a3.01 3.01 0 002.103 2.867 2.87 2.87 0 01-.995-.015.072.072 0 00-.066.023.072.072 0 00-.015.07 2.993 2.993 0 002.597 2.074 5.736 5.736 0 01-3.428 1.121c-.23 0-.46-.013-.688-.04a.072.072 0 00-.075.047.072.072 0 00.028.084 8.325 8.325 0 004.515 1.328c5.245 0 8.38-4.275 8.38-8.409 0-.115-.003-.23-.008-.343a5.979 5.979 0 001.444-1.513.072.072 0 00-.005-.085z"}));
}

Vector.defaultProps = {"viewBox":"0 0 16 12"};

module.exports = Vector;

Vector.default = Vector;
